import React from 'react';
import '../scss/components/section.scss';
import Header from '../components/header/header.jsx';
import PageTitle from '../components/page-title/page-title-v1/index.jsx';
import Footer from '../components/footer/footer-v1/index.jsx';
import dataFooter from '../assets/fake-data/data-footer.js';
import datawaller from '../assets/fake-data/data-ConnectWallet.js';
import { useNavigate, Link } from 'react-router-dom';


function ConnectWallet(props) {
    const navigate = useNavigate();

    return (
        <div className='wrapper-style' id='wrapper'>
            {<Header />}
            <PageTitle title='Select Your Business Type' />
            <div className="tf-section flat-connect-wallet">
                <div className="container">
                    <div className="row">
                        {
                            datawaller.map(item => (
                                <div className="col-xl-3 col-lg-4 col-md-6" key={item.id}>
                                    <div className="wrap-connect center">
                                        <div className={`popular absolute ${item.classAction}`}><h3 className="fw-4">Popular</h3></div>

                                        <div className="content text-t">
                                            <h3 className="fw-6"><Link to={item.link}>{item.title}</Link></h3>
                                            <p className="font-2">{item.desc}</p>
                                            <button
                                                style={{ height: "2em", width: "10em", padding: "0em", marginTop: "1em" }}
                                                onClick={() => navigate(item.link)}
                                            >
                                                Select
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
            {<Footer data={dataFooter} />}
        </div>
    );
}

export default ConnectWallet;

